<template>
  <div class="order-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[UnloadingOrder] }} Orders</span>
          <span class="sub-title">Unloading</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[LocalOrder] }} Orders</span>
          <span class="sub-title">Local</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[DirectOrder] }} Orders</span>
          <span class="sub-title">Direct</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryOrders } from '@/api/order'
import {
  DirectOrder,
  LocalOrder,
  OrderCompleted,
  OrderCreated,
  OrderProcessing,
  OtherOrder,
  UnloadingOrder
} from '@/core/models/order'
export default {
  name: 'OrderPageStats',
  data() {
    return {
      UnloadingOrder,
      LocalOrder,
      DirectOrder,
      OtherOrder,
      counts: {
        [UnloadingOrder]: 999,
        [LocalOrder]: 999,
        [DirectOrder]: 999
      }
    }
  },
  mounted() {
    this.countOrders(UnloadingOrder)
    this.countOrders(LocalOrder)
    this.countOrders(DirectOrder)
  },
  methods: {
    countOrders(type) {
      queryOrders({
        typeList: [type],
        statusList: [OrderCreated, OrderProcessing, OrderCompleted],
        size: 0
      }).then(res => {
        if (res) {
          this.counts[type] = res.total
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px !important;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
